<template>
    <div v-if="visible">
        <div class="modal-backdrop" role="dialog">
            <div class="modal" ref="modal">
                <header class="modal-header">
                    Explorer history
                    <button type="button" class="btn-close" @click="close">
                        <i class="fas fa-times"></i>
                    </button>
                </header>
                <section class="modal-body" style="overflow-y: scroll; overflow-x: hidden">
                    <div class="row">
                        <div class="col-sm-12 col-md-3" v-for="item in history" :key="item.component">
                            <div :class="['card shadow cursor-button', currentRoute(item.getRoute().name) ? 'active': '']">
                                <span v-if="!currentRoute(item.getRoute().name)" class="history-item-badge" @click="removeHistory(item.getComponent())">&times;</span>
                                <div class="card history-item" @click="openComponent(item)">
                                    <div class="card-header">
                                        <img class="img-fluid" :src="item.getThumbnail()"/>
                                    </div>
                                    <div class="card-body">
                                        <h5>{{$t(item.getTitle())}}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ExplorerHistory",
    data() {
        return {
            visible: false,
        }
    },

    mounted() {
        this.$eventBus.$on('exploreHistoryComp::toggle', () => {
            this.visible = !this.visible;
            if(this.visible) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        });
    },

    methods: {
        close() {
            document.body.classList.remove('overflow-hidden');
            this.visible = false;
        },

        openComponent(item) {
            if (this.$route.name !== item.getRoute().name) {
                this.visible = false;
                this.$router.push(item.getRoute());
            }
        },

        removeHistory(component) {
            this.$store.dispatch('explorerStore/remove', component);
        }
    },

    computed: {
        history() {
            return this.$store.getters['explorerStore/history'];
        },

        currentRoute() {
            return routeName => {
                return routeName === this.$route.name;
            }
        }
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1 !important;
    z-index: 9997;
}

.modal {
    width: calc(85%);
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px;
    display: flex;
    flex-direction: column;
    right: 0;
    left: unset;

}

.modal-header {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #b89453;
    justify-content: space-between;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #b89453;
    background: transparent;
}

input:checked + .slider {
    background-color: #b89453;
}

input:focus + .slider {
    box-shadow: 0 0 1px #b89453;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.history-item:hover {
    opacity: 0.7;
}

.history-item-badge {
    position: absolute;
    right: -15px;
    top: -15px;
    background: #b89453 !important;
    color: white;
    text-align: center;
    border-radius: 30px 30px 30px 30px;
    padding: 5px 17px;
    font-size: 20px;
    z-index: 10;
}

.active {
    border: 2px solid #b89453;
}
</style>
